export default __webpack_public_path__ + "static/media/cristina-del-re.18575903.svg";